// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"4b4dc65e","845":"2f58d8d8"}[chunkId] + ".chunk.js";
};